module.exports = __webpack_public_path__ + "img/login.f9f66a20.png";